import { render, staticRenderFns } from "./DocumentItemCardSales.vue?vue&type=template&id=e440aaa2&scoped=true"
import script from "./DocumentItemCardSales.vue?vue&type=script&lang=js"
export * from "./DocumentItemCardSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e440aaa2",
  null
  
)

export default component.exports